export default {
  label: {
    id: 'product_page_sticky_bar_free_shipping',
    defaultMessage: 'Free shipping and returns',
  },
}
